import { isPast } from 'date-fns';
import { styled } from 'styled-components';
import { Colors } from './Colors';

const modifiers = ({ allowPast }: { allowPast: boolean }) => ({
    modifiers: {
        past: allowPast ? null : isPast,
    },
    modifiersClassNames: {
        past: '--past',
        selected: '--selected',
        today: '--today',
    }
});

const Base = styled.div`
    .--past {
        opacity: .5;
    }
    .--today {
        background-color: ${Colors.slate100} !important;
    }
    .--selected {
        background-color: ${Colors.primary} !important;
        color: white !important;
    }
`;

export const DayPickerStyling = Object.assign(Base, { modifiers });
